import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';
import { Pool } from '../../../../../../apis/pool.api';

export function P00042FunctionFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;

  editValue(
    P00039DataRxTxIndex.Volet230_Installation,
    'vo230IConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
